export interface ChatTheme {
  colors?: Partial<Record<'primary' | 'background' | 'surface' | 'text' | 'userBubble' | 'assistantBubble', string>>;
  radius?: 'none' | 'sm' | 'md' | 'lg' | 'full' | number;
  mode?: 'light' | 'dark';
}
export interface Variants { buttons?: 'chips' | 'list'; carousel?: 'slider' | 'list' }
const LIGHT = { primary: '#4f46e5', background: '#ffffff', surface: '#f4f4f5', text: '#18181b', userBubble: '#4f46e5', assistantBubble: '#f4f4f5' };
const DARK = { primary: '#6366f1', background: '#0a0a12', surface: '#1c1c27', text: '#f4f4f5', userBubble: '#6366f1', assistantBubble: '#1f1f2b' };
const RADII = { none: '0px', sm: '6px', md: '10px', lg: '16px', full: '9999px' };
const VAR = { primary: '--osvi-color-primary', background: '--osvi-color-background', surface: '--osvi-color-surface', text: '--osvi-color-text', userBubble: '--osvi-color-user-bubble', assistantBubble: '--osvi-color-assistant-bubble' };
export const cssVar = (key: keyof typeof LIGHT): string => `var(${VAR[key]}, ${LIGHT[key]})`;
export function themeVariables(theme: ChatTheme | undefined): Record<string, string> {
  const colors = { ...(theme?.mode === 'dark' ? DARK : LIGHT), ...theme?.colors };
  // The user's bubble is brand-coloured unless the customer picks it separately.
  if (!theme?.colors?.userBubble && theme?.colors?.primary) colors.userBubble = theme.colors.primary;
  const out: Record<string, string> = {};
  for (const key of Object.keys(VAR) as (keyof typeof LIGHT)[]) out[VAR[key]] = colors[key];
  const radius = theme?.radius ?? 'md';
  out['--osvi-radius'] = typeof radius === 'number' ? `${radius}px` : RADII[radius];
  return out;
}
export function explicitThemeVariables(theme: ChatTheme | undefined): Record<string, string> {
  if (!theme) return {};
  if (theme.mode) return themeVariables(theme);
  const full = themeVariables(theme), out: Record<string, string> = {};
  for (const key of Object.keys(theme.colors ?? {}) as (keyof typeof LIGHT)[]) out[VAR[key]] = full[VAR[key]]!;
  if (theme.radius !== undefined) out['--osvi-radius'] = full['--osvi-radius']!;
  return out;
}
const applied = new WeakMap<HTMLElement, string[]>();
export function applyTheme(host: HTMLElement, theme: ChatTheme | undefined): void {
  for (const key of applied.get(host) ?? []) host.style.removeProperty(key);
  const variables = explicitThemeVariables(theme);
  for (const [key, value] of Object.entries(variables)) host.style.setProperty(key, value);
  applied.set(host, Object.keys(variables));
}
